import { useMemo } from 'react';

import { useFlags } from '../../../services/launchDarkly';
import { useStores } from '../../../stores/useStores';
import type { UpcomingMissionWidgetData, WidgetEntry } from '../types';

export function useUpcomingMissionWidgets() {
  const { missionsStore } = useStores();
  const { missions_v2_enabled, missions_v2_frontend_enabled } = useFlags();
  const missionsEnabled = missions_v2_enabled && missions_v2_frontend_enabled;
  const { upcomingMissionStartAt } = missionsStore;

  const upcomingMissionWidgets: UpcomingMissionWidgetData[] = useMemo(() => {
    const showUpcomingMission = Boolean(missionsEnabled && upcomingMissionStartAt);
    if (!showUpcomingMission) {
      return [];
    }

    return [
      {
        key: 'mission',
        dataTestId: 'mission-widget',
      },
    ];
  }, [upcomingMissionStartAt, missionsEnabled]);

  return useMemo(
    () =>
      upcomingMissionWidgets.map(
        (data): WidgetEntry<'upcomingMission'> => ({ data, type: 'upcomingMission', id: data.key }),
      ),
    [upcomingMissionWidgets],
  );
}
